import { Loading, Maintenance, ScreenSaver } from '@/core/blocks';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ROUTES, envVars } from './config';
import { useIdle } from './core';
import { Layout } from './layout';

import { PrivateRoutes } from './router';

import { useEffect, lazy, Suspense } from 'react';

const Home = lazy(() => import('./pages/home'));
const Quiz = lazy(() => import('./pages/quiz'));
const Leaderboard = lazy(() => import('./pages/quiz/leaderboard'));
const QuizPlay = lazy(() => import('./pages/quiz/play'));
const Shirts = lazy(() => import('./pages/shirts/id'));

function App() {
  const { globalLoading } = useIdle();

  useEffect(() => {
    const now = new Date();
    const target = new Date();

    target.setHours(9, 0, 0, 0);

    if (now > target) {
      target.setDate(target.getDate() + 1);
    }

    const delay = target.getTime() - now.getTime();

    const timeout = setTimeout(() => {
      window.location.reload();
    }, delay);

    return () => clearTimeout(timeout);
  }, []);

  if (envVars.underMaintenance) {
    return <Maintenance />;
  }

  if (globalLoading) {
    return <Loading />;
  }

  return (
    <>
      <ScreenSaver />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            <Route
              path={ROUTES.HOME}
              element={
                <Suspense fallback={<Loading />}>
                  <Home />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.QUIZ}
              element={
                <Suspense fallback={<Loading />}>
                  <Quiz />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.QUIZ_PLAY}
              element={
                <Suspense fallback={<Loading />}>
                  <QuizPlay />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.QUIZ_LEADERBOARD}
              element={
                <Suspense fallback={<Loading />}>
                  <Leaderboard />
                </Suspense>
              }
            />
            <Route
              path={ROUTES.SHIRTS.view}
              element={
                <Suspense fallback={<Loading />}>
                  <Shirts />
                </Suspense>
              }
            />
          </Route>
        </Route>
        <Route
          path={ROUTES.LOGIN}
          element={<div className='h-screen flex justify-center items-center text-8xl'>Login</div>}
        />
        <Route path='*' element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </>
  );
}

export default App;
